export default __webpack_public_path__ + "static/niw-0e60bada4d3ba3cc22fbb4fd42e917ba.png";